/**
 * All strings which can be specified in the "groups"
 * search query of the Agents/Users API read request
 * in VCCSS CM-API.
 *
 * NOTE: We declare those in a separate module,
 * since they will be used in two sibling submodules,
 * and we do not want to create a circular dependency.
 */
export const ApiGroups = Object.freeze({
  SSO: "sso",
  ACCOUNT: "account",
  PASSWORD: "password",
  PROFILE: "profile",
  SECURITY: "security",
  LOCALE: "locale",
  ADMIN: "admin",
  ADMIN_ROLE: "admin.role",
  AGENT: "agent",
  AGENT_CHAT: "agent.chat",
  AGENT_CRM: "agent.crm",
  AGENT_EMAIL: "agent.email",
  AGENT_EXTERNAL_CRM: "agent.external-crm",
  AGENT_INTERACTION: "agent.interaction",
  AGENT_PHONE: "agent.phone",
  AGENT_PHONE_DAR: "agent.phone.dar",
  AGENT_PHONE_OUTBOUND: "agent.phone.outbound",
  AGENT_PHONE_RECORDING: "agent.phone.recording",
  AGENT_SMTP: "agent.smtp",
  AGENT_SUPERVISOR: "agent.supervisor",
  AGENT_UI: "agent.ui",
  AGENT_RTR: "agent.rtr",
});

export const AllApiGroupValues = Object.values(ApiGroups);
